import { render, staticRenderFns } from "./activity_config.vue?vue&type=template&id=28fac0c9&scoped=true"
import script from "./activity_config.vue?vue&type=script&lang=js"
export * from "./activity_config.vue?vue&type=script&lang=js"
import style0 from "./activity_config.vue?vue&type=style&index=0&id=28fac0c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fac0c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fac0c9')) {
      api.createRecord('28fac0c9', component.options)
    } else {
      api.reload('28fac0c9', component.options)
    }
    module.hot.accept("./activity_config.vue?vue&type=template&id=28fac0c9&scoped=true", function () {
      api.rerender('28fac0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/group_buying/ex_warehouse/form/components/activity_config.vue"
export default component.exports